import React from 'react';
import {
  TextField,
  TextFieldProps,
} from '@mui/material';

type OtpFieldProps = Omit<TextFieldProps, 'color'> & {
  ref?: React.RefObject<HTMLInputElement | null>,
  nextRef?: React.RefObject<HTMLInputElement | null>,
  previousRef?: React.RefObject<HTMLInputElement | null>,
  fontSize?: string | number,
}

const OtpDigitField: React.FC<OtpFieldProps> = ({
  error, value, onChange, nextRef, previousRef, ref, fontSize, ...rest
}) => {
  React.useEffect(() => {
    if (value) {
      nextRef?.current?.focus();
    } else if (!value && previousRef?.current?.value) {
      previousRef?.current?.focus();
    }
  }, [value, previousRef?.current, nextRef?.current]);

  return (
    <TextField
      color="primary"
      onChange={(e) => {
        if ((!value && Number(e.target.value) <= 9 && Number(e.target.value) >= 0) || !e.target.value) {
          onChange?.(e);
        }
      }}
      error={!!error}
      value={value ?? ''}
      autoComplete="off"
      {...rest}
      sx={{
        fieldSet: {
          backgroundColor: '#fff',
          borderWidth: '2px',
        },
        input: {
          color: 'primary.main',
          p: 0,
          fontSize: fontSize ?? 16,
          zIndex: 1,
          textAlign: 'center',
        },
      }}
      InputProps={{
        inputProps: {
          inputMode: 'numeric',
        },
        sx: {
          height: '100%',
        },
      }}
    />
  );
};

export default OtpDigitField;
